import React from 'react';
import { Column, Row } from '@grubhubprod/gh-cookbook-react';
import { InvoicePaymentMethod } from 'src/components/enterprise/features/Corporate/components/Form/InvoicePaymentWrapper/InvoicePaymentMethod/InvoicePaymentMethod';
import { MaxInvoiceAmountControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoicePaymentWrapper/MaxInvoice/MaxInvoiceAmountControl';
import { useShowMaxInvoiceAmount } from 'src/components/enterprise/features/Corporate/components/Form/InvoicePaymentWrapper/MaxInvoice/hooks/useMaxInvoiceAmount';

export function InvoicePaymentWrapper(): JSX.Element {
  const { showMaxInvoiceInput } = useShowMaxInvoiceAmount();

  return (
    <>
      <Row gutter={12}>
        <Column phone={6} gutter={12}>
          <InvoicePaymentMethod
            name="invoicePaymentMethod"
            id="invoicePaymentMethod"
          />
        </Column>
        <Column phone={6} gutter={12}>
          {showMaxInvoiceInput && (
            <MaxInvoiceAmountControl
              name="maxCreditCardCharge"
              id="maxCreditCardCharge"
            />
          )}
        </Column>
      </Row>
    </>
  );
}
